export default {
sets: `Sarjat`,
stats: `Tilastot`,
discover: `Huomata`,
guides: `Oppaat`,
settings: `asetukset`,
unsupportedBrowserBody: `Flash -kortit eivät tue tätä selainta. Lataa Chromen tai Operan uusin versio tai lataa iPhone tai Android -sovellus`,
unsupportedBrowserTitle: `Tukematon selain`,
noData: `Ei tietoa näytettävistä`,
contactUsTitle: `Rakastamme kuulla, kuinka käyttäjämme käyttävät sovellustamme ja miten voimme parantaa. Pudota meille viesti, jossa on kyselyjä, kuten ominaisuuspyynnöt tai virheraportit`,
rateAppStore: `Korko AppStore -sovelluksessa`,
rateGoogle: `Arvio Google Playssa`,
close: `kiinni`,
shareFriends: `Jaa ystävien kanssa`,
noCardsQ: `Eikö sinulla ole salamakortteja?`,
noCardsS: `Valitse kokoelmastamme aloittaaksesi`,
suggestSet: `Ehdottaa`,
createOwn: `Luo oma`,
search: `Hae`,
loading: `Ladataan`,
words: `Sanat`,
downloads: `Lataukset`,
export: `Viedä`,
import: `Tuonti`,
importing: `Tuonti ... älä sulje sovellusta`,
importPreview: `Tuo esikatselu`,
howQuizlet: `Kuinka tuoda tietokilpailusta`,
cards: `Kortit`,
importPreviewStatus: `__ Ehdot ovat valmiita liitettäväksi olemassa oleviin ___ -kortteihin`,
importPaste: `Liitä korttisi yllä olevaan Textareaan`,
setTotalLimitReached: `Sinulla voi olla vain 3000 korttia studysetissä`,
studying: `Opiskelu`,
learnt: `Oppinut`,
mastered: `Hallitsematon`,
new: `Uusi`,
noTerm: `Ei termiä`,
noDef: `Ei määritelmää`,
cardSaved: `Kortti tallennettu`,
reviews: `Arvostelut`,
practices: `Käytännöt`,
flashcards: `Salamakortit`,
alerts: `Hälytykset`,
corrects: `Korjaa`,
mistakes: `Virheet`,
reviewCycle: `Tarkistusjakso`,
reviewsLeft: `Arvostelut jäljellä`,
lastReview: `Viimeinen arvostelu`,
nextReview: `Seuraava arvostelu`,
hideHistory: `Piilota täysi historia`,
showHistory: `Näytä täysi historia`,
strength: `Vahvuus`,
star: `Tähti`,
image: `Kuva`,
tag: `Tag`,
added: `lisä`,
removed: `poistettu`,
reviewedFrom: `Tarkistettu __: sta`,
notifications: `Ilmoitukset`,
reviewedPractice: `Tarkistettu __ ___ harjoittelu`,
successfully: `onnistuneesti`,
unsuccessfully: `epäonnistuneesti`,
termUpdated: `Termi päivitetty`,
defUpdated: `Määritelmä päivitetty`,
flashcardCreated: `Luotu salamakortti`,
dropboxImage: `Sinun on otettava käyttöön Dropbox -synkronointi lisätäksesi kuvia`,
deleteImgConfirm: `Haluatko varmasti poistaa tämän kuvan?`,
uploading: `Lataus`,
save: `Tallentaa`,
uploadImageFail: `Kuvan lataaminen epäonnistui`,
imageUploaded: `Kuva ladattu`,
setNotFound: `Studyset ei löydy!`,
notEnoughCards: `Ei tarpeeksi kortteja!`,
of: `__ ___`,
on: `Päällä`,
off: `Vinossa`,
auto: `Automaattinen`,
manual: `Manuaalinen`,
pronounce: `Lausua`,
practiceCompleted: `Olet suorittanut tämän käytännön`,
closePractice: `Läheinen käytäntö`,
autoplay: `Automaattinen toisto`,
secFlipSecNext: `__ sekuntia, ___ s. Seuraava`,
autopronounce: `Automaattinen`,
onlyTerm: `Ainoa termi`,
onlyDef: `Ainoa määritelmä`,
termAndDef: `Termi ja määritelmä`,
savePractice: `Tallenna harjoittelu?`,
continueLater: `Jatkaa myöhemmin`,
deletePractice: `Poistaa harjoittelua`,
term: `Termi`,
def: `Määritelmä`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Arviointitavoite`,
dailyGoal: `Päivittäinen tavoite`,
edit: `Muokata`,
setUp: `Perustaa`,
noRecentPractice: `Sinulla ei ole viimeaikaisia ​​käytäntöjä`,
continueLastReview: `Jatka viimeinen arvostelu`,
dueCards: `Asianmukaiset kortit`,
studyNow: `Opiskella nyt`,
newCards: `Uudet kortit`,
terms: `sanat`,
defs: `määritelmät`,
validCardsOf: `Vain __ valituista ___ -korteista voidaan harjoittaa, koska muut puuttuvat joko termi tai määritelmä`,
reviewCards: `Arvostelukortit`,
customizePractice: `Räätälöidä käytäntö`,
next: `Seuraava`,
iWasRight: `olin oikeassa`,
printProAlert: `Osta Pro -tilaus tulostaaksesi yli 20 salamakorttia`,
print: `Tulosta`,
printWidth: `Termi-def-leveys`,
printFont: `Fonttikoko`,
printBorder: `Reuna`,
printMargin: `Sivun marginaali`,
printPadding: `Sanan pehmuste`,
preparingFile: `Tiedoston valmistelu`,
notificationsBlocked: `Ilmoitukset eivät ole käytössä, ota käyttöön ilmoitukset puhelimesi asetuksista`,
ranOutOfWords: `Kortit loppuu, käynnistä uudelleen aloittamista koskeva käytäntö`,
ranOutOfWordsShort: `Sanojen loppuminen`,
ranOutOfWordsBody: `Avaa sovellus ajoittaaksesi uusia sanoja`,
proIncreaseNotifications: `Voit lisätä kokonaisilmoituksia 10: stä 50: een premium -versiossa.`,
schedule: `Ajoittaa`,
frequency: `Taajuus`,
mode: `Tila`,
tM1: `1 minuutti`,
tM2: `2 minuuttia`,
tM5: `5 minuuttia`,
tM10: `10 minuuttia`,
tM15: `15 minuuttia`,
tM30: `30 minuuttia`,
tH1: `1 tunti`,
tH2: `2 tuntia`,
termPassive: `Termi passiivinen`,
termActive: `Aktiivinen termi`,
defPassive: `Def passiivinen`,
defActive: `Def -aktiivinen`,
scheduledIn: `Suunniteltu __ minuuttiin`,
scheduledAlertsProT: `Lisää aikatauluvia hälytyksiä ammattilaisella`,
scheduledAlertsProB: `Voit lisätä suunniteltuja hälytyksiä 10: stä 50: een Pro -paketin avulla`,
seeFeatures: `Katso ominaisuuksia`,
defAndTerm: `Määritelmä ja termi`,
termHoldDef: `Termi, pidä määritelmän paljastaminen`,
defHoldTerm: `Määritelmä, pidä paljastaa termi`,
notificationType: `Ilmoitustyyppi`,
copyToClipboard: `Kopioi leikepöydälle`,
enterAuthCode: `Anna valtuutuskoodisi`,
invalidCode: `Virheellinen koodi`,
copied: `Kopioi!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Napauta löytääksesi kaikki premium -ominaisuudet oppiaksesi tehokkaammin omassa tahdissasi`,
promoBtn: `Löydä kaikki ominaisuudet`,
setDropboxH2: `Dropbox -synkronointi`,
setDropboxPOff: `Ota Dropbox Synkronointi käyttöön sarjojen, salamakorttien, tunnisteiden ja edistyksen varmuuskopioidun ja päivityksen ajan.`,
setDropboxPOn: `Tietosi varmuuskopioidaan ja synkronoidaan laitteiden välillä.`,
setDropboxBtn: `Synkronoida`,
status: `Tila`,
syncNow: `Synkronoitu nyt`,
contact: `Ottaa yhteyttä`,
contactUs: `Ota meihin yhteyttä`,
useFromBrowser: `Käyttää selaimesta`,
useFromBrowserMsg: `Käy tietokoneesi flashcardsmadesimple.com ja palauta kortit ja lisenssi ottamalla käyttöön Dropbox Sync`,
termsPrivacy: `Termit ja yksityisyys`,
dailyReviewGoal: `Päivittäinen arviointi tavoite`,
numberTerms: `Termien lukumäärä`,
selectTerm: `Valitse termivihjellä`,
selectDef: `Valitse määritelmävihje`,
pronounceTerm: `Lausua termillä vihje`,
pronounceDef: `Lausua määritelmävihje`,
typeTerm: `Kirjoita termivihje`,
typeDef: `Kirjoita määritelmävihje`,
quizTypes: `Suositut tietokilpailutyypit`,
spacedRepetition: `Välimatka toistoaikataulu`,
spacedRepetitionP: `Epävälin toisto antaa sinun hallita sanoja vähemmän ponnisteluilla etämällä asteittain tarkistusaika. Oletusohjelma on 1-3-7-15-31 päivää, mutta voit myös asettaa mukautetun.`,
spacedRepetionScheduleItem: `__ Päiviä ___ arvostelun jälkeen (päivä ____)`,
atLeastOneSchedule: `Vaaditaan vähintään yksi aikataulu`,
revisionLimitReached: `Sinä saavutit enimmäismäärän määrän`,
addReviewSchedule: `Lisää uusi arvosteluohjelma`,
autoMarkLearnt: `Automaattinen merkki oppi jälkeen`,
autoMarkMastered: `Automaattinen merkki hallittu`,
tagManager: `Tag -hallinta`,
delete: `Poistaa`,
addTag: `Lisää uusi tunniste`,
tagDeletionH: `Merkitä`,
tagDeletionP: `Haluatko varmasti poistaa tämän tunnisteen?`,
cancel: `Peruuttaa`,
daysAfterLastReview: `Päivät viimeisen katsauksen jälkeen`,
linkDropbox: `Linkkipisara`,
startSync: `Aloittaa synkronointi`,
starred: `Tähti-`,
images: `Kuvat`,
tags: `Tunnisteet`,
types: `Tyypit`,
activeDays: `Aktiiviset päivät`,
inactiveDays: `Passiiviset päivät`,
longestStreak: `Pisin viiva`,
dailyGoalsCompleted: `Päivittäiset tavoitteet valmistuvat`,
dailyGoalsFailed: `Päivittäiset tavoitteet epäonnistuivat`,
typePairs: `Tyyppiparit`,
reviewTypes: `Tarkista tyypit`,
typePractice: `Tyypillinen käytäntö`,
pronouncePractice: `Lausua käytäntö`,
selectPractice: `Valitse käytäntö`,
notificationReview: `Ilmoituskatsaus`,
flashcardReview: `Flashcard Review`,
studyset: `Sturisetti`,
enterStudysetName: `Anna nimi Studyset -niminen`,
studysetName: `Enter Setin nimi`,
termType: `Termi tyyppi / lang`,
defType: `Määritelmätyyppi / lang`,
exportCards: `Vientikortit`,
importCards: `Tuontikortit`,
quiz: `Tietokilpailu`,
showingOutOfCards: `Näytetään ___ -korteista`,
showingAllCards: `Näyttämällä kaikki kortit, kirjoita yllä olevaan hakupalkkiin tai napauta mitä tahansa tagit suodattaaksesi`,
recording: `Äänite`,
downloadSet: `Lisää sarjoihini`,
addNewCard: `Lisää uusi kortti`,
saveStudyset: `Tallenna opintojoukko`,
studysetDeletionH: `Sturiset -deleetio`,
studysetDeletionP: `Oletko varma, että haluat poistaa tämän studysetin, tämä myös poistaa kaikki sisältävät kortit.`,
cardDeletionH: `Kortinpoisto`,
cardDeletionP: `Oletko varma, että haluat poistaa tämän kortin`,
cardLimitReached: `Sinulla voi olla vain 3000 korttia studysetissä`,
limitExceeded: `Raja ylitetty`,
atLeastTenCards: `Lisää vähintään 10 korttia aloittaaksesi käytännöt`,
searchInAll: `Hae kaikissa opintojoukkoissa`,
noMatch: `Ei osumia`,
atLeastThreeChars: `Kirjoita vähintään 3 merkkiä etsiäksesi`,
noSets: `Ei sarjoja`,
startingSync: `Aloitussynkronointi`,
noSetsP: `Valitse aloittamista alla olevista vaihtoehdoista`,
startingSyncP: `Saamme tietosi Dropboxista, tämä saattaa viedä jonkin aikaa`,
createNewStudyset: `Luo uusi Studyset`,
restoreFromBackup: `Palauta varmuuskopiotiedostosta`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Valitse harjoittelutyyppi`,
noDueCards: `Ei vielä erääntyneitä salamakortteja, ennen tarkistamasi salamakortit alkavat näkyä täällä valittujen etäisyyden toistoaikataulun jälkeen auttamaan sinua hallitsemaan sanoja vähemmän vaivaa ja aikaa`,
noNewCards: `Ei uusia kortteja opiskelemaan`,
subscriptionH: `Osta Pro nauttimaan kaikista ominaisuuksista ja tukemaan jatkuvaa kehitystä.`,
buyLifetimePro: `Osta Lifetime Pro __`,
restorePurchase: `Palauta osto`,
termsPrivacyC: `Ehdot ja tietosuojakäytäntö`,
licenceShare: `Jos ostit lisenssin toiselta laitteelta, voit jakaa sen tämän laitteen kanssa ottamalla käyttöön Dropbox -synkronointi molemmilla laitteilla`,
enterTagName: `Kirjoita tunnisteen nimi`,
invalidName: `Epäkelpo nimi`,
create: `Luoda`,
name: `Nimi`,
tagName: `Tunnisteen nimi`,
color: `Väri`,
back: `Takaisin`,
rowSeparator: `Rivin erotin`,
termDefSeparator: `Termi - DEF -erotin`,
output: `Tulos`,
inputCards: `Syöttökortit`,
review: `Arvostelu`,
language: `Kieli`,
archiveReversible: `Arkisto (palautettavissa asetuksista)`,
deletePermanent: `Poista (peruuttamaton)`,
archivedCards: `Arkistoidut kortit`,
masteredCards: `Masteroidut kortit`,
due: `Erääntyvä`,
reviewed: `Tarkistettu`,
markReviewed: `Merkki tarkistettu`,
markMastered: `Merkillä hallittu`,
forXYCards: `__ ___ -kortteille`,
createdAtSortBy: `Luomispäivä`,
lastReviewedSortBy: `Viimeinen arvostelupäivä`,
reviewCountSortBy: `Arvostelujen määrä`,
strengthSortBy: `Vahvuus`,
termSortBy: `Aakkosellinen termi`,
definitionSortBy: `Aakkosellinen def.`,
ascSortBy: `Nouseva`,
descSortBy: `Laskeva`,
featureSync: `Tutki mitä tahansa, missä tahansa, milloin tahansa salamakorttiesi kanssa synkronoidut kaikki laitteet`,
featureSpacedrepetition: `Tutki yleistä edistymistäsi ja palaa takaisin harjoitteluun harjoitteluun`,
featureNotifications: `Lataa oppiminen edes avaamatta sovellusta joustavilla ilmoiksilla`,
featureFlashcards: `Automaattisen leimahduskortit, kun kädet tai silmäsi ovat kiireisiä, mutta sinulla on silti käyttämätön huomio`,
featureQuiz: `Vastaa, kirjoita, kuuntele tai valitse harjoittaaksesi salamakorttejasi`,
featureStats: `Hanki parempaa tietoa korteistasi ja tuloksistasi ja etsi kaikkia salamakorttisi sarjoja`,
featureImport: `Emme koskaan tallenna mitään tietoja sinusta, ja voit viedä ja tuoda kaikki tietosi helposti`,
featurePrint: `Hanki jonkin verran oppimista tulostamalla salamakortit ja tee oma opiskeluun liittyvä takila`,
splashIntro: `Tutki kaikkia salamakorttejasi missä tahansa tahdissa ja tyylissäsi`,
selectSortOrder: `Lajittelujärjestys`,
selectSortProp: `Lajitella omaisuus`,
applyFilters: `Levitä suodattimia`,
selectSetType: `Mitä haluat harjoitella?`,
getStarted: `Aloittaa`,
tapToUnarchive: `Napauta kortteja, joita haluat estää`,
untitled: `Nimettömä`,
sortHintNew: `Näet kortit, jotka on luotu pisin ensin sitten`,
sortHintDue: `Näet kortit, jotka ovat olleet pisin ensin`,
sortHintOther: `Näet kortteja, joita ei ole tutkittu pisin ensin`,
flashcardsWhen: `, kun kädet tai silmäsi ovat kiireisiä, jopa kuunnellessasi musiikkia / podcasteja`,
notificationsWhen: `, sillä kun olet ulkona ja haluat vain nopeaa opinto -bittejä`,
quizWhen: `, kun voit kiinnittää täydellistä huomiota opiskeluun, hallitsemaan korttejasi`,
features: `ominaisuudet`,
ratings: `Arviot`,
notificationDailyCatchUpBody: `UUSI: __, erääntyvä: ___, opiskelu: ____, oppinut: _____, hallittu: ______`,
notificationDailyCatchUpTitle: `Päivittäinen kiinniotto`,
reviewedJN: `Tarkistettu juuri nyt`,
customUpdated: `Mukautettu teksti päivitetty`,
customTextField: `Synonyymit, esimerkit jne.`,
field: `Ala`,
link: `Linkki`,
backToParentCard: `Takaisin vanhempaan korttiin`,
discard: `Hylätä`,
failedImageLoad: `Kuvan lataaminen epäonnistui, varmista, että olet kytketty Internetiin`,
printDIYLabel: `Diy oma luova paperipohjainen opiskeluasetus, jaa kanssamme luomuksesi ja saat esiin sovelluksessa.`,
reviewGraphChart: `Katsaustaajuus`,
langNotSet: `Kieli ei ole asetettu`,
pronouncationLangInfo: `Ääntämisen mahdollistamiseksi sinun on valittava termi ja määritelmäkieli. Kaiutinmerkki ilmestyy kielten viereen, jos laitteesi tukee sitä kieltä`,
clearFilters: `Tyhjennyssuodatin`,
subFreeUnlimited: `Rajoittamaton opiskelu, salamakortit, käytännöt, etsintä ja synkronointi`,
customFields: `Mukautetut kentät`,
subLinks: `Korttilinkit`,
subPrint: `Tulostus- / studisetti`,
subNotifications: `Ilmoitus ennen sovelluksen avaamista`,
subCardsStudysets: `Kortit / studyset`,
subRevisionCycles: `Mukautetut tarkistussyklit`,
subscriptionHEnd: `Pro -päivitys osoittaa meille, että pidät kovaa työtämme arvokkaana ja antaa meille rohkaisua ja kahvia jatkaaksesi uusien uskomattomien asioiden parantamista ja luomista.`,
subFree: `Vapaa`,
subPro: `Ammattilaiset`,
guideSpacedRepetition: `Kuinka välittömät toistotyöt ja harjoittelutyypit`,
guideSearch: `Etsintä ja suodatus`,
guideSync: `Ota varmuuskopio ja synkronoi laitteiden välillä`,
guidePronunciation: `Ota ääntäminen`,
guideImport: `Korttien tuonti poistuvista lähteistä`,
guideAccess: `Kenellä on pääsy tietoihini?`,
guideData: `Mitä tietoja keräämme?`,
guideContact: `Tarvitsetko apua missään muussa? Kirjoittakaa meille`,
arrowStrength: `Aseta kuinka hyvin tunnet tämän kortin`,
arrowImage: `Lisää kuvia`,
arrowField: `Lisää mukautettuja tekstikenttiä`,
arrowTag: `Liitä tunnisteet`,
arrowStar: `Mark suosikki`,
arrowLink: `Linkki muihin kortteihin`,
arrowGoal: `Aseta itsellesi päivittäinen arviointitavoite`,
arrowDue: `Tutkimussanat, jotka on tarkoitus tarkistaa`,
arrowNew: `Opintokortteja, joita ei ole vielä tarkistettu`,
arrowMastered: `Jos sinulla ei ole erääntyneitä tai uusia kortteja, voit tarkistaa masteroidut kortit pitääksesi ne hallinnassa`,
arrowImport: `Tuo nykyiset salamakortit`,
arrowNewCard: `Lisää uudet salamakortit`,
dropboxStep1: `1. Hanki pääsykoodi Dropboxista kirjautumalla sisään`,
dropboxStep1Btn: `Kirjaudu sisään Dropboxilla`,
dropboxStep2: `2. Syötä pääsykoodi alla`,
dropboxStep2Input: `Kirjoita koodi tähän`,
dropboxStep3: `3. Aloita synkronointi`,
alreadyLinked: `Jo linkitetty, napauta`,
selectCardsToLink: `Valitse linkittävä kortti`,
unsupportedLangP: `Valitse kieli, joka tukee lausuntoa sarjan asetuksista`,
links: `Linkit`,
emailUs: `Lähetä meille sähköpostia`,
whatsappUs: `Whatsapp me`,
printMinHeight: `Min. rivin korkeus`,
exportType: `Vientitiedostotyyppi`,
generateFileText: `Luoda tiedosto`,
generatatingFile: `Tiedoston luominen`,
verySmall: `Hyvin pieni`,
small: `Pieni`,
normal: `Normaali`,
big: `Iso`,
veryBig: `Hyvin iso`,
repeatNTimes: `Toista __ kertaa`,
pause: `Tauko`,
for: `puolesta`,
say: `Sanoa`,
defShort: `Määritelty`,
times: `ajat`,
autoplayPreferences: `Aseta automaattisesti`,
autoPlay1: `Tauko edellisen sanan jälkeen`,
autoPlay2: `Term -lausuntojen lukumäärä`,
autoPlay3: `Tauko ennen määritelmän paljastamista`,
autoPlay4: `Määritelmän lukumäärä`,
autoPlay5: `Tauko ennen seuraavan sanan näyttämistä`,
autoPlay6: `Toista sama salamakortti`,
startAutoPlay: `Aloita automaatti`,
autoPlayOffConfirm: `Sammuta automaatti manuaaliset ohjaimet mahdollistamaan`,
turnOff: `Sammuttaa`,
keepPn: `Jatka`,
foundIn: `Löytyy __`,
repeat: `toistaa`,
stop: `Lopettaa`,
listenInBreak: `Tiesitkö? Voit kuunnella musiikkia / podcasteja taukoissa`,
contextSearch: `Kontekstihaku`,
contextSearchText: `Hanki esimerkkejä siitä, kuinka __ käytetään eri lauseissa`,
transalteSearch: `Kääntää`,
translateSearchText: `Käännä __ - ___`,
synonymSearch: `Synonyymihaku`,
synonymSearchText: `Etsi __ synonyymit`,
selectToAdd: `Valitse tulokset, jotka haluat lisätä tähän korttiin`,
addToCard: `Lisää valittu kortti`,
hideFromPractice: `Piiloutua`,
setLanguageRequired: `Valitse Studyset -yksityiskohtien termien ja määritelmien kieli`,
fieldNeedsText: `Kirjoita jotain tähän kenttään ennen kuin etsit`,
possibleDupe: `Mahdollinen kopio`,
loadNextXCards: `Lataa seuraava __ kortit`,
repeatPractice: `Toista nämä __ -kortit`,
keepScreenOnInfo: `Saatat joutua säätämään automaattisen lukituksen asettamista, jotta näyttö on päällä automaattisen leimaamisen aikana.`,
siteLoginH2: `SFM -tili`,
siteLoginP: `Voit käyttää flash -kortteja, jotka on tehty yksinkertaisen tilien jakamaan salamakortit ystävien, opiskelijoiden tai koko yhteisön kanssa.`,
logOut: `Kirjautua ulos`,
logIn: `Kirjaudu sisään`,
createAccount: `Luo uusi tili`,
signUp: `Kirjaudu`,
username: `Käyttäjänimi`,
email: `Sähköposti`,
password: `Salasana`,
networkError: `Verkkovirhe`,
fillAllDetails: `Täytä kaikki yksityiskohdat`,
noUserWithDetails: `Ei käyttäjää löydettyihin yksityiskohtiin`,
userAlreadyExists: `Annettu sähköposti tai käyttäjänimi on jo olemassa`,
signUpOrLoginToCont: `Rekisteröidy tai kirjaudu sisään jatkaaksesi?`,
atLeastOneCardToShare: `Ainakin yksi kortti vaaditaan jakamaan`,
publishingStudyset: `Kustantaja`,
updatesDetected: `Havaittuja päivityksiä, haluatko jatkaa paikallisten tietojen päivittämistä? (Poistettu: __, päivitetty: ___, uusi: ____)`,
updatesApplied: `Päivitykset sovelletut`,
alreadyUpToDate: `Jo ajan tasalla`,
practiceTypeArrow: `Löydä eri tavoin käytännössä`,
share: `Jaa`,
sharingModalIntro: `Jaa salamakortit tässä sarjassa ystävien, opiskelijoiden tai koko yhteisön kanssa.`,
whatIsShared: `Mikä on jaettu`,
whatIsNotShared: `Mitä ei jaeta`,
whatIsSharedText: `Aseta nimi, aseta termi kieli, selkeä kieli, kaikki mukana olevat kortit, joissa on termejä, määritelmiä, mukautettuja tekstikenttiä ja kuvia`,
whatIsNotSharedText: `Kaikki korttivahvuudet, tähdet, linkit, tunnisteet ja arvosteluhistoriaasi`,
checkForSharedUpdates: `Tarkista päivitykset Creatorilta`,
fetchUpdates: `Hae päivitykset`,
youSharedStudyset: `Jaoit tämän studysetin`,
publishChanges: `Tallenna ja julkaise muutoksia`,
redeem: `Lunastaa`,
noAds: `Ei mainoksia`,
dupeDetection: `Kaksoiskappaleet`,
coffeeFeature: `Kahvi auttaa meitä kehittämään lisää ominaisuuksia`,
shareLink: `Jaa linkki`,
coffeeForUs: `Saat elinikäisen lisenssin vain __: lle, joka antaa Emily 6 kahvia, Dominik 3 -kahvia ja Russ 3 kahvia, jotka polttavat meitä noin 39 tuntia tämän sovellustapahtuman parantamiseksi`,
sharingCards: `Jakamiskortit`,
published: `Julkaistu`,
alreadyHaveAccount: `Onko sinulla jo tili?`,
notAlreadyHaveAccount: `Eikö sinulla ole vielä tiliä?`,
startPractice: `Aloittaa harjoittelu`,
selectQuizTypes: `Valitse tietokilpailutyypit`,
correct: `Oikea`,
incorrect: `väärä`,
yes: `Joo`,
no: `Ei`,
levelSilver: `Hopeataso __`,
levelGold: `Kultataso __`,
levelPlatinum: `Platinataso __`,
levelDiamond: `Timanttitaso __`,
levelJade: `Jade -taso __`,
reviewsLeftGoal: `__ Arvostelut päivittäistä tavoitetta varten`,
dailyGoalAchieved: `Päivittäinen tavoite saavutettu`,
share: `Jaa`,
rateApp: `Arvostele sovellus`,
allStats: `Kaikki tilastot`,
reviewTimeError: `Aikakatkaisu virheen jälkeen`,
reviewTimeCorrect: `Aikakatkaisu oikean jälkeen`,
pronounceTermAfterReview: `Ääntä termi tarkistuksen jälkeen`,
pronounceDefinitionAfterReview: `Ääntä määritelmä katsauksen jälkeen`,
practice: `Harjoitella`,
notificationsScheduledInfo: `__ Ilmoitukset on suunniteltu, voit sulkea sovelluksen nyt`,
wellDone: `Hyvin tehty`,
keepItUp: `Jatka samoin`,
youRock: `Sinä rokkaat`,
niceOne: `Hyvä`,
lnSelect: `Valitse kieli`,
sampleData: `Ei arvosteluja, jotka näyttävät näytetiedot`,
reviewFreq: `Katsaustaajuus`,
selectPractice: `Harjoittelu: Valitse`,
spellPractice: `Harjoittelu: loitsu`,
connectPractice: `Harjoittelu: Yhdistä`,
languages: `Kieli (kielet`,
languagesPairs: `Kieliparit`,
shareArrow: `Jaa asetettu ystävien, opiskelijoiden tai koko yhteisön kanssa`,
cardsPerRound: `Kortit / pyöreä`,
showAll: `Näytä kaikki`,
supportedLangsVary: `Tuettu kielet vaihtelevat`,
practiceWithoutSave: `Harjoittelua ei tallenneta`,
practiceWithoutSaveBody: `Et ole lisännyt tätä studysettiä kokoelmaan, haluatko lisätä sen nyt tutkimuksen etenemisen tallentamiseksi?`,
saveSetNow: `Tallenna kortit kokoelmaan`,
continueWithoutSaveSave: `Aloita harjoittelu ilman pelastamista`,
createdBy: `Luonut`,
setSavedToYourCollection: `Opintojoukko tallennettu kokoelmaan`,
accountBackupDisclaimer: `Huomaa, että tätä tiliä voidaan käyttää vain studitsien jakamiseen muiden kanssa, eikä sitä voida käyttää tutustumisten tai salamakorttien varmuuskopiointiin tai synkronointiin. Kaikkien tietojen synkronointi ja varmuuskopiointi käytä Dropbox -synkronointia`,
syncEnabled: `Synkronointi käytössä, haettaessa käynnissä olevaa sisältöä`,
searchAllSets: `Hakututkimusjoukot muilta käyttäjiltä`,
anyLanguage: `Mikä tahansa kieli`,
trendingIn: `Trendi jtk`,
manualBackups: `Manuaalinen varmuuskopio`,
manualBackupCreate: `Luo manuaalinen varmuuskopio`,
confirmManualImport: `Oletko varma, että haluat korvata kaikki nykyiset tiedot tällä varmuuskopiolla? Tätä suositellaan uusille laitteille vain ilman tietoja`,
importFromManualBackup: `Tuonti varmuuskopiosta`,
imgOfflineSets: `Automaattinen lataa kuvia offline-oppimista varten`,
unsupportedDeviceCache: `Tämä ominaisuus on saatavana vain iOS- tai Android -sovelluksesta`,
shareChanges: `Jaa __ muutoksia`,
publiclySearchable: `Käyttäjien haettavissa`,
description: `Kuvaus`,
restoreFromDropboxBackup: `Palauta Dropbox -varmuuskopiosta`,
imageCacheStudysetSub: `[vain iOS & Android] Lataa kuva offline -opiskeluun`,
keywordsOrLangNeeded: `Sinun on annettava joitain avainsanoja tai yksi kieli`,
dropboxAlreadyLinked: `Dropbox -tili on jo linkitetty`,
noSetUpdateAccess: `Sinulla ei ole pääsyä tämän tutkimusjoukon muokkaamiseen.`,
confirmSetOwnerLogin: `Jos olet varma, että olet omistaja, kokeile kirjautua tilillesi uudelleen.`,
uninitedRestriction: `Edistyksen tallentamiseksi sinun on ensin lisättävä tämä studyset kokoelmaan`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Varastointi epäonnistui`,
consolidateStorageDone: `Tallennusyhdistyminen, salli jopa tunnin, että DropBox lopettaa vanhojen tiedostojen poistamisen ennen kuin kirjaudut sisään uuteen laitteeseen.`,
consolidatingStorage: `Varastointi ...`,
deleteAccount: `Poista tili`,
consolidateStorageDescription: `Tämä toimenpide uudelleen varmuuskopiotiedostosi, joten uusien laitteiden asettaminen on nopeampaa`,
consolidatingStorageConfirm: `Varmista, että kaikki muutokset ovat jo lopettaneet synkronoinnin, älä synkronoi muita laitteita, kun tämä prosessi tapahtuu. Haluatko jatkaa?`,
consolidateStorage: `Vakiinnuttaa`,


}